<app-chat-button
  [unreadCount]="unreadCount()"
  [matMenuTriggerFor]="chatMenu"
></app-chat-button>

<mat-menu #chatMenu="matMenu" class="chat-menu__panel">
  <div class="chat-menu__header" (click)="$event.stopPropagation()">
    <h3 class="chat-menu__title">{{ 'CHAT.TITLE' | translate }}</h3>
  </div>

  <div class="chat-menu__list" (click)="$event.stopPropagation()">
    <app-chat-room-list
      [rooms]="rooms"
      [isLoading]="isLoading()"
      [compact]="true"
      (roomSelected)="onRoomSelected($event)"
    ></app-chat-room-list>
  </div>

  <div class="chat-menu__footer">
    <button mat-menu-item class="btn btn--sm btn--no-bg" (click)="onSeeAll()">
      {{ 'CHAT.SEE_ALL' | translate }}
    </button>
  </div>
</mat-menu>
